export default __webpack_public_path__ + "static/media/icon-medicamentos.9be83da1.svg";